// Persistence layer for "which AWS accounts are mid-onboard to CK Billing" so
// the loading UI survives a browser reload. Scoped to the current tab via
// sessionStorage and keyed per customer so impersonation / multi-tenant tabs
// don't bleed.

export const STALE_MS = 30 * 60 * 1000; // 30 minutes
const KEY_PREFIX = 'prism.onboardingInflight.';

export function buildKey(customerId) {
  return KEY_PREFIX + customerId;
}

// loadInflight returns { set: Set<accountId>, meta: Map<accountId, {addedAt}> }
// reading from sessionStorage. Entries older than STALE_MS are dropped.
export function loadInflight(customerId) {
  const empty = { set: new Set(), meta: new Map() };
  if (!customerId) return empty;
  const raw = sessionStorage.getItem(buildKey(customerId));
  if (!raw) return empty;

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return empty;
  }
  if (!parsed || typeof parsed !== 'object') return empty;

  const cutoff = Date.now() - STALE_MS;
  const set = new Set();
  const meta = new Map();
  for (const [id, addedAt] of Object.entries(parsed)) {
    if (typeof addedAt !== 'number' || addedAt < cutoff) continue;
    set.add(id);
    meta.set(id, { addedAt });
  }
  return { set, meta };
}

// persistInflight writes the current Set+Map to sessionStorage. An empty set
// removes the key entirely so we don't leave stale {} entries lying around.
export function persistInflight(customerId, set, meta) {
  if (!customerId) return;
  const key = buildKey(customerId);
  if (set.size === 0) {
    sessionStorage.removeItem(key);
    return;
  }
  const out = {};
  for (const id of set) {
    const entry = meta.get(id);
    out[id] = entry ? entry.addedAt : Date.now();
  }
  sessionStorage.setItem(key, JSON.stringify(out));
}
